import { IconButton } from '@mui/material';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useSwapContactOwner } from '../../../sic-lib/api/hooks/useContact';
import { Contact } from '../../../sic-lib/types/Contact';
import { useAppSelector } from '../../../store/hooks';
import { UserAvatar } from '../../Settings/Users/UserAvatar';
import FollowerDialogSelect from '../FollowerDialogSelect/FollowerDialogSelect';
import ContactFollowers from './ContactFollowers';
import OwnerDialogSelect from './OwnerDialogSelect';

export default function ContactOwners({ contact }: Props) {
    const { classes } = useStyles();
    const [showDialog, setShowDialog] = React.useState<boolean>(false);
    const users = useAppSelector(state => state.user.users);
    const handleShowDialog = () => setShowDialog(true);
    const { mutate: swapContactOwner } = useSwapContactOwner(contact.contactId);

    const contactUsers = React.useMemo(() => {
        return {
            contactOwner: contact.owners.find(contact => contact.isPrimary === true),
        };
    }, [contact.owners]);

    const handleSwapOwner = async (text: string | undefined) => {
        swapContactOwner({
            userName: text,
            isPrimary: true,
        });
        setShowDialog(false);
    };

    return (
        <>
            <Grid container direction="row" wrap="nowrap">
                <Grid item container xs={3} direction="column" wrap="nowrap">
                    <Grid item container direction="row" wrap="nowrap" columnSpacing={1}>
                        <Grid item xs="auto">
                            <Typography variant="subtitle2">Owner</Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <OwnerDialogSelect
                                prevOwner={contactUsers.contactOwner?.userName}
                                handleSwapOwner={handleSwapOwner}
                                showDialog={showDialog}
                                setShowDialog={setShowDialog}
                                handleShowDialog={handleShowDialog}
                                label="Current Owner"
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs="auto" style={{ minHeight: '2rem' }}>
                        <IconButton onClick={handleShowDialog}>
                            <UserAvatar
                                users={users}
                                userName={contactUsers.contactOwner?.userName}
                            />
                        </IconButton>
                    </Grid>
                </Grid>
                <Divider
                    orientation="vertical"
                    variant="fullWidth"
                    light={true}
                    flexItem={true}
                    style={{ margin: '0 .5rem 0 0 ' }}
                />
                <Grid item container xs={9} direction="column" wrap="nowrap">
                    <Grid
                        item
                        container
                        direction="row"
                        wrap="nowrap"
                        columnSpacing={1}
                        style={{ marginLeft: 0 }}
                    >
                        <Grid item xs="auto">
                            <Typography variant="subtitle2">Followers</Typography>
                        </Grid>
                        <Grid item xs="auto">
                            <FollowerDialogSelect contact={contact} />
                        </Grid>
                    </Grid>
                    <Grid item container xs="auto" direction="row" wrap="wrap" spacing={1}>
                        <ContactFollowers contact={contact} />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

const useStyles = makeStyles()(() => ({}));

interface Props {
    contact: Contact;
}
